import { useIntl } from "react-intl";
import React from "react";
import ErratasContainer from "./erratas.container";

function ErratasContainerIntl() {
    const intl = useIntl()
    return (
        <ErratasContainer intl={intl}></ErratasContainer>
    );
  }

  export default ErratasContainerIntl


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/erratas/erratas.intl.js